
window.$ = window.jQuery;
// import Router from "./utils/Router";



//Globals scripts
import globals from "./globals";


// Includes
import "../../partials/includes";

// Globals
import "../../partials/components/globals";

// import "../../partials/components/collezioni";

// Search
import "../../partials/components/search";

// Sliders
import "../../partials/components/sliders";
// Accordions
import "../../partials/components/accordion";




// Lists

import "../../partials/components/lists";

// Text
import "../../partials/components/text";


// Heads
import "../../partials/components/heads";

// Inputs
import "../../partials/components/inputs";

// Hero
import "../../partials/components/hero";

// Hero
import "../../partials/components/hero-text";

import "../../partials/components/tabs";

// Maps
import "../../partials/components/maps";
// Timeline
import "../../partials/components/timelines";
// Video
import "../../partials/components/videos";
// Blocks
import "../../partials/components/blocks";
// Gallery
// import "../../partials/components/galleries";
// Popups
import "../../partials/components/popups";


// Form
import "../../partials/components/forms/v1/form";


// Animations
import "../js/animations/split-text";

//woocommerce
// import "../../woocommerce/js";
import "../js//woocommerce/index";


import {ScrollTrigger} from "./gsap-premium/esm/all"
import { gsap } from "gsap";

// gsap.registerPlugin(ScrollSmoother);



// Inizializzare GSAP e ScrollTrigger
gsap.registerPlugin(ScrollTrigger);





$(".form-toggle__form").hide();
$(".form-toggle__button").click(function(e) {
  e.preventDefault();
  $(this)
    .closest(".form-toggle")
    .find(".form-toggle__form")
    .slideToggle();
});


document.addEventListener('click', function(event) {
  if (event.target.tagName === 'A' && event.target.getAttribute('href') === '#') {
    event.preventDefault();
  }
});

// Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {

    // On-page links
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $("html, body").animate(
          {
            scrollTop: target.offset().top - 120,
          },
          1000,
          function() {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) {
              // Checking if the target was focused
              return false;
            } else {
              $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            }
          }
        );
      }

      // // Controllo sull'hash del link
      // if (this.hash === "#orari") {
      //   console.log("orari");
      //   event.preventDefault(); // Impedisce il comportamento predefinito del link

      //   $(".menu-tendina").addClass("menu-tendina--active");
      //   $(".backplate").addClass("backplate--open");
      //   $(".hamburger").addClass("is-active");

      //   $(".lista-orari").addClass("lista-orari--active");
      //   $(".menu-tendina").addClass("menu-tendina--orari");
      // } else {
      //     $(".menu-tendina").removeClass("menu-tendina--active");
      //     $(".backplate").removeClass("backplate--open");
      //     $(".hamburger").removeClass("is-active");
      //     $(".lista-orari").removeClass("lista-orari--active");
      //     $(".menu-tendina").removeClass("menu-tendina--orari");
      // }


    }
  });

// new Router([
//   // {
//   //   attribute: ".swiper-container",
//   //   instance: Swiper,
//   // },
//   // {
//   //   attribute: ".page-storia",
//   //   instance: Storia,
//   // },
//   // {
//   //   attribute: ".testo-home",
//   //   instance: Testo,
//   // },
//   // {
//   //   attribute: ".scroll-reveal",
//   //   instance: "ScrollMagic/scrollmagic-reveal.js",
//   //   fn: () => {},
//   // },
// ]).watch();

// import Rellax from "rellax";

// var rellax = new Rellax(".rellax", {
//   center: true,
// });
// var rellaxShop = new Rellax(".rellax-shop", {
//   center: false,
// });

// window.onload = function() {
//   jQuery(".presentation-category__img-wrapper").addClass("loaded");
//   rellax.refresh();
//   rellaxShop.refresh();
// };

// let parent = document.querySelector('.sticky').parentElement;

// while (parent) {
//     const hasOverflow = getComputedStyle(parent).overflow;
//     if (hasOverflow !== 'visible') {
//         console.log(hasOverflow, parent);
//     }
//     parent = parent.parentElement;
// }



jQuery(document).ready(function($) {
  $('.read-more__content').hide();
  $('.read-more__button').click(function() {
      $('.read-more__content').slideToggle();
      $(this).toggleClass('read-more__button--active')
  });
});



